import { render, staticRenderFns } from "./ProductDoc.vue?vue&type=template&id=0120071d"
import script from "./ProductDoc.vue?vue&type=script&lang=ts"
export * from "./ProductDoc.vue?vue&type=script&lang=ts"
import style0 from "./ProductDoc.vue?vue&type=style&index=0&id=0120071d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports